import { Button as AntdButton, Modal as AntdModal } from 'antd';
import Icon from '@ant-design/icons';
import styled from 'styled-components';
import CloseIconSvg from '../../Icons/CloseIconSvg';

export const Modal = styled(AntdModal)`
  & .ant-modal-content {
    border-radius: 3px;
  }

  & .ant-modal-body {
    padding: 24px 0 0;
  }

  & .ant-modal-close-x {
    width: 50px;
    margin-top: 6px;

    :hover .anticon {
      color: #b5b5b5;
    }
  }
`;

export const CloseIcon = styled(Icon).attrs({
  component: CloseIconSvg,
})`
  color: #c1c1c1;
  font-size: 10px;
  transition: 0.3s color linear;
`;

export const Title = styled.h4`
  text-align: center;
  font-size: 18px;
  line-height: normal;
  color: #333333;
  margin: 0 0 20px;
`;

export const FloatingButton = styled(AntdButton)`
  position: absolute;
  left: 0;
  bottom: -16px;
  transform: translate(0, 100%);
  width: 100%;
  height: unset;
  padding: 12px 20px;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
`;
